// Vowels and consonants as the alignments count them: the five vowels, the
// German umlauts with them; Y is a consonant.
const VOWELS = new Set(['A', 'E', 'I', 'O', 'U', 'Ä', 'Ö', 'Ü']);

export function isVowel(letter: string): boolean {
  return VOWELS.has(letter);
}

export function vowelCount(word: string): number {
  let n = 0;
  for (const ch of word) if (isVowel(ch)) n++;
  return n;
}

export function consonantCount(word: string): number {
  return Array.from(word).length - vowelCount(word);
}

/** The letters of a word, one per star. */
export function lettersOf(word: string): string[] {
  return Array.from(word);
}
